import { render, staticRenderFns } from "./newPerson.vue?vue&type=template&id=4f59fea6&scoped=true"
import script from "./newPerson.vue?vue&type=script&lang=js"
export * from "./newPerson.vue?vue&type=script&lang=js"
import style0 from "./newPerson.vue?vue&type=style&index=0&id=4f59fea6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f59fea6",
  null
  
)

export default component.exports